import { render, staticRenderFns } from "./CVExample.vue?vue&type=template&id=03ed2361&"
import script from "./CVExample.vue?vue&type=script&lang=js&"
export * from "./CVExample.vue?vue&type=script&lang=js&"
import style0 from "./CVExample.vue?vue&type=style&index=0&id=03ed2361&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports